export interface DictionaryPapIndexEntity {
    id: number | undefined;
    indexName: string;
    validSince: Date;
    indexValue: number;
    uoM: string;
}
